import React, {Component, Fragment} from "react";
import SFXButtonComponent from "../SFXButtonComponent";
import ChatConversationService from "../../services/chat/ChatConversationService";
import CreateConversationComponent from "./CreateConversationComponent";
import UserSessionService from "../../services/UserSessionService";
import ToastHelper from "../../utils/ToastHelper";
import ViewConversationComponent from "./ViewConversationComponent";

export default class ChatComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            customType: this.props.customType,
            context: this.props.context,

            isChatActive: false,
            hasConversation: false,
            isShowingChat: false,
            chatMessageToSend: '',
            isLoading: true

        }
    }

    componentDidMount() {

        let conversationId = UserSessionService.retrieveConversationId();
        let hasConversationId = conversationId !== undefined && conversationId !== null && conversationId > 0;

        let newState = {isLoading: false}
        if (hasConversationId) {
            ChatConversationService.retrieveConversation(conversationId).then((conversation) => {
                if (conversation.id) {
                    newState.conversation = conversation;
                    newState.hasConversation = conversation.status === 'OPEN';
                }
                this.setState(newState)
            });
        } else {
            this.setState(newState);
        }
    }

    loadChat() {
        if (this.state.isShowingChat) {
            this.setState({isShowingChat: false});
        } else {
            this.setState({isLoading: true}, () => {
                let newState = {isLoading: false, isShowingChat: true}
                if (this.state.hasConversation) {
                    ChatConversationService.retrieveConversation(this.state.conversation.id).then(
                        response => {
                            if (response.id) {
                                newState.hasConversation = response.status === 'OPEN';
                            } else {
                                newState.hasConversation = false;
                            }
                            this.setState(newState);
                        }
                    )
                } else {
                    this.setState(newState);
                }
            })
        }
    }

    render() {
        if (this.state.isLoading) {
            return <Fragment>

            </Fragment>
        }
        return <Fragment>

            {this.renderViewConversationComponent()}

            {this.renderChatCircle()}

            {this.renderConversationComponent()}

        </Fragment>
    }

    renderChatCircle() {
        let icon = "fa fa-comment";
        if (this.state.isShowingChat) {
            icon = "fa fa-times"
        }
        return <SFXButtonComponent
            className={"live-chat-circle-container"}
            onClick={() => {
                this.loadChat();
            }}
        >
            <i className={icon + " live-chat-circle-icon"}/>
        </SFXButtonComponent>
    }

    renderConversationComponent() {
        return <Fragment>
            {
                this.state.isShowingChat && !this.state.hasConversation &&
                <div className={"live-chat-container"}>
                    <CreateConversationComponent
                        customType={this.state.customType}
                        context={this.state.context}
                        onConversationCreated={(conversation) => {
                            UserSessionService.storeConversationId(conversation.id);
                            this.setState({
                                hasConversation: true,
                                conversation: conversation,
                                chatMessageToSend: ''
                            })

                            if (this.props.onConversationCreated) {
                                this.props.onConversationCreated(conversation);
                            }
                        }}
                        onConversationFailedToCreated={(error) => {
                            if (this.props.onConversationFailedToCreate) {
                                this.props.onConversationFailedToCreate(error);
                            } else {
                                ToastHelper.formatError(error);
                            }
                        }}
                    />
                </div>
            }
        </Fragment>
    }

    renderViewConversationComponent() {
        return <Fragment>
            {
                this.state.hasConversation && this.state.isShowingChat &&
                <div className={"live-chat-sendbird-container"}>
                    <ViewConversationComponent
                        conversation={this.state.conversation}
                        userId={this.state.conversation.userId}
                        onFailedToLoadUser={(error) => {
                            if (this.props.onFailedToLoadUser) {
                                this.props.onFailedToLoadUser(error);
                            } else {
                                ToastHelper.formatError(error)
                            }
                        }}
                    />
                    {/*<p>*/}
                    {/*    /!*TODO DECIDE IF THIS <p> is staying *!/*/}
                    {/*    Once the conversation has been completed. <br/>*/}
                    {/*    To start a new conversation minimise the chat and then open it again*/}
                    {/*</p>*/}
                </div>
            }
        </Fragment>
    }
}